import * as React from 'react'
import type { Language } from 'codegen/types'
import { useTranslation } from 'react-i18next'
import { prefetchTranslations } from '@repo/react-i18next-plugins/prefetch-translations'
import { toStudioIntlLocale } from '@repo/studio-i18n-translations/load-translation'

/**
 * Fetches the translation chunks for a language before the user commits to it.
 *
 * Normalises through `toStudioIntlLocale` so the chunks are requested under the
 * same locale key `useReloadLanguage` asks for on the actual switch — otherwise
 * Chinese would prefetch `zh_Hans` and then reload `zh-CN`, missing the cache.
 */
export function usePrefetchLanguage() {
  const { i18n } = useTranslation()

  return React.useCallback(
    (language: Language) => {
      prefetchTranslations(i18n, toStudioIntlLocale(language) ?? language).catch(() => {
        // A guess that fails to load costs nothing: switching for real reloads
        // resources anyway, so the user pays the original network round trip.
      })
    },
    [i18n],
  )
}
